export type RuntimeAppConfig = {
  userPoolId?: string;
  userPoolClientId?: string;
  apiBaseUrl?: string;
};

let runtimeAppConfigPromise: Promise<RuntimeAppConfig> | undefined;

const fetchRuntimeAppConfig = async (): Promise<RuntimeAppConfig> => {
  try {
    const response = await fetch("/app-config.json", {
      cache: "no-store",
    });

    if (!response.ok) {
      return {};
    }

    const config = (await response.json()) as RuntimeAppConfig;
    return {
      userPoolId: config.userPoolId,
      userPoolClientId: config.userPoolClientId,
      apiBaseUrl: config.apiBaseUrl,
    };
  } catch {
    return {};
  }
};

export const getRuntimeAppConfig = () => {
  if (!runtimeAppConfigPromise) {
    runtimeAppConfigPromise = fetchRuntimeAppConfig();
  }

  return runtimeAppConfigPromise;
};
